// --- START OF FILE ExtrairDadosStyle.js ---

import styled from "styled-components";

export const ExtrairContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 40px;
    box-sizing: border-box;
    background-image: url('/textura.jpg');
    background-size: cover;
    background-attachment: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ContentBox = styled.div`
    background: rgba(30, 30, 30, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 8px;
    padding: 30px 40px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    max-width: 900px;
    width: 100%;
    margin: 0 auto;
`;

export const Header = styled.div`
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    
    h2 {
        margin: 0;
        color: #E6AA3A;
        font-size: 28px;
    }
    p {
        margin: 5px 0 0 0;
        color: #fff;
        opacity: 0.8;
    }
`;

export const Step = styled.div`
    margin-bottom: 30px;
    
    .title {
        display: block;
        font-size: 18px;
        color: #fff;
        font-weight: 600;
        margin-bottom: 15px;
    }
`;

export const Filters = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
        font-size: 14px;
        color: #fff;
        opacity: 0.8;
        text-transform: uppercase;
    }
    
    input, select {
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 15px;
        color: #fff;
        border-radius: 6px;
        font-size: 16px;
        &:focus { outline: none; border-color: #E6AA3A; }
    }
`;

export const Download = styled.div`
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;

    button {
        background: #27ae60;
        color: #fff;
        border: none;
        border-radius: 6px;
        padding: 15px 50px;
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s;

        &:hover:not(:disabled) { 
            background: #2ecc71;
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(46, 204, 113, 0.4);
        }
        &:disabled {
            background: #555;
            cursor: not-allowed;
            opacity: 0.7;
        }
    }
`;

// Componentes legados para manter a estrutura do seu JSX
export const TypeAndFilter = styled.div``;
export const SelectBox = styled.div``;